
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import LinkChooserDialog from "@/components/Reusable/CustomInputs/LinkInput/LinkChooserDialog.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, LinkChooserDialog, TextInput }
})
export default class URLInput extends Vue {
  @Prop()
  value!: string | null;

  @Prop({ default: true })
  multiline!: boolean;

  dialogOpen = false;
  dialogLoading = false;

  emit(url: string | null) {
    if (!url) {
      this.$emit("input", null);
    }

    const newUrl = url?.trim().replace(/<(br\s+)?(br)?>/gi, "");
    this.$emit("input", newUrl);
  }

  onLinkSelected(link: string) {
    this.emit(link);
  }

  openDialog() {
    this.dialogOpen = true;
  }

  closeDialog() {
    this.dialogOpen = false;
  }
}
